import { useState, useEffect } from "react";
import { Box, Typography, Tooltip, IconButton, CardMedia } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import Detail from "../../../main/detail/Detail";
import { rsActiveMenu, rsProgress, rsParentCom } from "../../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseHomeAdvertising } from "./UseHomeAdvertising";
import { DataGrid, faIR } from "@mui/x-data-grid";
import CustomPagination from "../../../components/CustomPagination";
import EditIcon from "@mui/icons-material/Edit";
import DeleteRow from "../../../components/DeleteRow";
import { Container, Draggable } from "react-smooth-dnd";
import { arrayMove } from "react-sortable-hoc";
import CancelIcon from "@mui/icons-material/Cancel";
import CloseIcon from "@mui/icons-material/Close";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

export default function HomeAdvertisings(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [msParentCom, setMsParentCom] = useRecoilState(rsParentCom);
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const { GetHomeAdvs, deleteAdvItem, updateAdvItem } = UseHomeAdvertising();
  const [model, setModel] = useState();
  const [pageState, setPageState] = useState({
    page: 1,
  });
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });
  const [sendModel, setSendModel] = useState();
  const [removedIndex, setRemovedIndex] = useState();

  useEffect(() => {
    if (location.state && location.state.AdvID) {
      setProgress(true);
      GetHomeAdvs(location.state.AdvID, (callback) => {
        setSendModel(callback.items.reverse());
        setModel(callback);
      });
    }
  }, [location.state]);

  const onDrop = ({ removedIndex, addedIndex }) => {
    const updater = (items) =>
      arrayMove(items, removedIndex, addedIndex).map((item, idx) => {
        return { ...item, orderRow: idx + 1 };
      });
    setRemovedIndex(addedIndex + 1);
    setSendModel(updater);
  };

  useEffect(() => {
    if (sendModel && removedIndex) {
      let send = {
        Id: "",
        orderRow: "",
      };
      let newModel = sendModel.find((m) => m.orderRow == removedIndex);
      send.Id = newModel.id;
      send.orderRow = sendModel.length - newModel.orderRow + 1;
      setProgress(true);
      updateAdvItem(send, "", (call) => {
        GetHomeAdvs(model.aid, (callback) => {
          setSendModel(callback.items.reverse());
          setModel(callback);
        });
        setRemovedIndex(undefined);
      });
    }
  }, [removedIndex]);

  const newFunc = () => {
    return navigate("/advertisingmanagement/addAdvertising", {
      state: {
        model: model.items,
        AdvID: model.aid,
        adverID: model.id,
        componentFaTitle: location.state.componentFaTitle,
      },
    });
  };

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "ID",
      headerAlign: "center",
      hide: true,
    },
    {
      field: "orderRow",
      headerName: "ردیف",
      width: 80,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "عملیات",
      sortable: false,
      width: 150,
      headerAlign: "center",
      align: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <>
            <Tooltip title="ویرایش">
              <IconButton
                onClick={() => {
                  return navigate("/advertisingmanagement/editAdvertising", {
                    state: {
                      model: cellValues.row,
                      AdvID: model.aid,
                      adverID: model.id,
                      componentFaTitle: location.state.componentFaTitle,
                    },
                  });
                }}
              >
                <EditIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="حذف">
              <IconButton
                onClick={() => {
                  setDeleteState({
                    show: true,
                    name: cellValues.row.title,
                    id: cellValues.row.id,
                  });
                }}
              >
                <CloseIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
          </>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        backButtonDef: {
          state: location.state,
          replace: true,
        },
        backURL: msParentCom.backUrl,
        title: "مدیریت محتوا",
        childs: [
          { name: msActiveMenu.pageTitle, url: msParentCom.parentComs },
          {
            name: "مدیریت" + " " + location.state.componentFaTitle,
            url: "/advertisingmanagement",
          },
        ],
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          // height: "100%",
          gap: 5,
        }}
      >
        {sendModel && sendModel.length ? (
          <Container
            onDrop={onDrop}
            orientation="horizontal"
            behaviour="move"
            style={{
              width: "100% !important",
              direction: "ltr",
              display: "flex",
              justifyContent: "flex-end",
            }}
            dropPlaceholder={{
              animationDuration: 150,
              showOnTop: true,
              className: "cards-drop-preview",
            }}
          >
            {sendModel.map((model, i) => {
              return (
                <Draggable
                  key={model.id}
                  style={{
                    width: "50%",
                    height: "auto",
                    cursor: "grab",
                  }}
                  order={model.orderRow}
                >
                  <Box
                    sx={{
                      mb: 3,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <Box
                      sx={{
                        border: "1px solid #d9d9d9",
                        borderRadius: 3,
                        position: "relative",
                        my: 1,
                        p: 1,
                        pb: 0,
                        mr: 1,
                        display: "flex",
                        alignItems: "flex-end",
                      }}
                    >
                      <LazyLoadImage
                        height="auto"
                        effect="blur"
                        src={
                          model.image ? model.image : "/static/img/NoAdv.png"
                        }
                        width="100%"
                      />
                      <Box
                        sx={{
                          position: "absolute",
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "flex-end",
                          zIndex: 1000,
                          left: 5,
                          width: "100% !important",
                          height: "100%",
                        }}
                      >
                        <CancelIcon
                          sx={{ color: "secondary.main", cursor: "pointer" }}
                        />
                      </Box>
                    </Box>
                    <Typography variant="subtitle2">
                      {model.orderRow}
                    </Typography>
                  </Box>
                </Draggable>
              );
            })}
          </Container>
        ) : (
          <Box
            width="800px"
            sx={{
              border: "1px solid #d9d9d9",
              p: 1,
              borderRadius: 3,
              my: 1,
              mb: 3,
              mr: 1,
              display: "flex",
              alignItems: "flex-start",
            }}
          >
            <CardMedia component="img" image="/static/img/NoAdv.png" />
          </Box>
        )}
        <Box sx={{ height: "30rem" }}>
          <DataGrid
            className="ltr-grid"
            localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
            columns={columns}
            rows={model ? model.items : []}
            page={pageState.page - 1}
            pageSize={20}
            Pagination
            onPageChange={(newPage) => {
              setPageState((old) => ({ ...pageState, page: newPage + 1 }));
            }}
            rowCount={model && model.length ? model.length : 1}
            disableColumnMenu
            hideFooterSelectedRowCount
            components={{
              Pagination: CustomPagination,
            }}
            componentsProps={{
              pagination: {
                newFunc: newFunc,
                rowCount: model && model.length ? model.length : "",
              },
            }}
            initialState={{
              sorting: {
                sortModel: [
                  {
                    field: "orderRow",
                    sort: "asc",
                  },
                ],
              },
            }}
          />
        </Box>
        <DeleteRow
          deleteState={deleteState}
          setDeleteState={setDeleteState}
          type={"آیتم"}
          callback={() => {
            setProgress(true);
            deleteAdvItem(deleteState.id, () => {
              GetHomeAdvs(model.aid, (callback) => {
                setSendModel(callback.items.reverse());
                setModel(callback);
              });
            });
          }}
        ></DeleteRow>
      </Box>
    </Detail>
  );
}
